import React, {useContext} from 'react';

const SessionContext = React.createContext(null);

export const useSessionContext = () =>  useContext(SessionContext) ;

export default SessionContext;